
// src/api/axiosInstance.js
import axios from 'axios';


export const ip = process.env.REACT_APP_API_BASE_URL;
export const wsIp = process.env.REACT_APP_WS_URL;

const axiosInstance = axios.create({
    baseURL: ip,
});


axiosInstance.interceptors.request.use((config) => {
    const token = localStorage.getItem('authToken');
    const tokenType = localStorage.getItem('tokenType');
    if (token && tokenType) {
        config.headers.Authorization = `${tokenType} ${token}`;
    }


    return config;
});


axiosInstance.interceptors.response.use(

    (response) => response,

    (error) => {




        if (error.response && error.response.status === 401) {
            localStorage.removeItem('authToken');
            localStorage.removeItem('tokenType');
            // optional: redirect to login page
            //window.location.href = '/login';
        } else if (error.response.status === 403) {
            const detail = error.response.data.detail;
            if (detail?.type === "banned") {
                alert("User is banned until: " + detail.message);  // <-- concatenate
                localStorage.removeItem('authToken');
                localStorage.removeItem('tokenType');
                window.location.href = '/';
            }

        }



        return Promise.reject(error);
    }
);

export default axiosInstance;